import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";
import { getFileXlsx } from "../templates/CostUpload/FileReceiver";


export const svcDownloadFile = async (fileId, fileName, downloadFile) => {

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }
    // let queryParams = new URLSearchParams(params).toString();

    const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.svcDownload}${fileId}/${downloadFile}`;

    // const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwUploadHistory}`;

    const response = await getAPI(apiUrl, tokenInfo);
    // await fetch(apiUrl, {
    //     method: "GET",
    //     headers: localDatabaseUrls.temp_headers
    //     // headers: {
    //     //     Authorization: 'Bearer ' + tokenInfo.id_token,
    //     //     Principal: tokenInfo.access_token,
    //     // },
    // });

     if (response.ok) {
        await getFileXlsx(fileName, response, downloadFile);
    } else {
        const errorData = await response.json();
        response.status !== 200 ? AlertManager.error(errorData.message, { contactSupport: false }) : AlertManager.error(response.statusText, { ContactSupport: false });
        //  response.status === 404 ? AlertManager.error("File not found in bucket", { contactSupport: false }) : AlertManager.error("Error downloading file", { contactSupport: false });
    }
};